
export enum GrantConcessionEnum {
    UNA_VEZ = 'UNA_VEZ',
    REPETITIVO = 'REPETITIVO'
}
